// import JS files
import axios from 'axios';
import '../kickstart';

import { h, render } from 'preact';

import App from '../App';

window.addEventListener(
  'message',
  function(e) {
    var target = e.target[0].self;
    // console.log(e);
    // console.log(e);
    // console.log(e.source);
    // console.log(e.data);
    // console.log(target);

    // axios({
    //   method: 'get',
    // })
    //   .then(response => {
    //     console.log(response);
    //   })
    //   .catch(error => {
    //     console.log('ERROR');
    //     console.log(error);
    //   });
  },
  false
);

function loadIframe(iframe_ID) {
  const frame = document.getElementById(iframe_ID);
  // console.log(iframe_ID);
  // console.log(frame);

  if (frame) {
    frame.onload = function() {
      console.log('myframe is loaded');
    };
  }

  if (frame) {
    try {
      frame.contentWindow.postMessage('message', '*');
    } catch (ex) {
      console.log('an error occured');
    }
  }
}

export default loadIframe;

render(<App />, document.getElementById('shell'));
